@if(PaginaJornalOutputDto){
  <div class="resultado-autenticidade">
    <div class="cabecalho-listagem-retorno-autenticidade">
      <span>Código Válido!</span>
      <button type="button" class="btn-fechar" (click)="clickClose()" aria-label="Fechar resultado">X</button>
    </div>
    <div class="row row-resultado">
      <div class="col-lg-2 col-12"><p><strong>Data</strong><br />{{PaginaJornalOutputDto.dataPublicacao | date: 'dd/MM/yyyy'}}</p></div>
      <div class="col-lg-4 col-12"><p><strong>Caderno</strong><br />{{PaginaJornalOutputDto.descricao}}</p></div>
      @if (PaginaJornalOutputDto.tipoVisualizacaoMateria !== tipoVisualizacaoMateria.HTML) {
        <div class="col-lg-2 col-12"><p><strong>Página</strong><br />{{PaginaJornalOutputDto.pagina}}</p></div>
      }
      <div class="col-lg-auto col-12 acoes-resultado">
        <button type="button" class="btn-visualizar-publicacao"
          (click)="BaixarArquivo()"
          (keyup.enter)="BaixarArquivo()">
            Baixar
        </button>
        @if (PaginaJornalOutputDto.tipoVisualizacaoMateria === tipoVisualizacaoMateria.HTML) {
          <button type="button" class="btn-visualizar-publicacao" (click)="visualizarPublicacaoHtml()">Visualizar</button>
        } @else {
          <a style="text-decoration: none;" href="" id="visualizarPagAutenticidade" class="btn-visualizar-publicacao">Visualizar</a>
        }
      </div>
    </div>
  </div>
}
@else {
  <div class="resultado-autenticidade">
    <div class="cabecalho-listagem-retorno-autenticidade" style="background-color: #e4a127;">
      <span>Código Inválido!</span>
      <button type="button" class="btn-fechar" (click)="clickClose()" aria-label="Fechar resultado">X</button>
    </div>
  </div>
}
